
export const removeDuplicates = (array) => {
    var result = array.reduce((unique, o) => {
      if (!unique.some(obj => obj.id === o.id && obj.id === o.id)) {
        unique.push(o);
      }
      return unique;
    }, []);
    
    return result;
}


export const removeDuplicatesChannel = (array) => {
  var result = array.reduce((unique, o) => {
    if (!unique.some(obj => obj.id === o.offers.id && obj.id === o.offers.id)) {
      unique.push(o);
    } return unique
  }, [])
  return result
}